import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5 d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Worker rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Configure rates for workers")
], -1)
const _hoisted_4 = { class: "d-flex flex-column flex-md-row flex-row mt-4" }
const _hoisted_5 = { class: "w-100 w-md-auto" }
const _hoisted_6 = { class: "mx-0 mx-md-4 my-4 my-md-0 w-100 w-md-auto" }
const _hoisted_7 = { class: "w-100 w-md-auto" }
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BranchesDropdown = _resolveComponent("BranchesDropdown")!
  const _component_SkillsDropdown = _resolveComponent("SkillsDropdown")!
  const _component_CurrenciesDropdown = _resolveComponent("CurrenciesDropdown")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_WorkerRatesDataTable = _resolveComponent("WorkerRatesDataTable")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BranchesDropdown, {
            modelValue: _ctx.query.branchID,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.branchID) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_SkillsDropdown, {
            modelValue: _ctx.query.skillID,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.skillID) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            ref: "currencyForm",
            "validation-schema": _ctx.validationSchema,
            onSubmit: _cache[3] || (_cache[3] = ev => ev.preventDefault())
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Field, { name: "currencyId" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_CurrenciesDropdown, _mergeProps({
                    class: "h-100",
                    size: "large"
                  }, field, {
                    "is-disabled": _ctx.loadingCurrency || !_ctx.hasQuery,
                    modelValue: _ctx.currencyId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currencyId) = $event))
                  }), null, 16, ["is-disabled", "modelValue"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "currencyId" })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ], 512), [
          [_vShow, _ctx.hasQuery]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_ctx.query.skillID != '' && _ctx.query.branchID != '')
          ? (_openBlock(), _createBlock(_component_WorkerRatesDataTable, {
              key: 1,
              selectedSkill: _ctx.query.skillID,
              onHasChanges: _cache[4] || (_cache[4] = data => (_ctx.hasChanges = data)),
              branchID: _ctx.query.branchID,
              onSaveRates: _ctx.handleSaveRates,
              onSaveRatesModal: _ctx.handleSaveRatesModal,
              ref: "workerRatesTable"
            }, null, 8, ["selectedSkill", "branchID", "onSaveRates", "onSaveRatesModal"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 2,
              description: "Please select branch and skill."
            }))
    ])
  ]))
}